import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import FormFieldPassword from "../../input/FormFieldPassword";
import Form from "../../layout/Form";
import useTriggeredAPICall from "../../../hooks/fetch-hooks/useTriggeredAPICall";
import { useAuthInfo } from "../../../context/AuthContext";

import { errorToast, successfulToast } from "../../../util/toastNotifications";
import { isValidPassword } from "../../../util/stringUtils";

import Logo from "../../../assets/images/logo.svg";

const ChangePassword = ({ history, match }) => {
  const [formErrors, setFormErrors] = useState({});
  const [password, setPassword] = useState({
    new: "",
    verify: "",
  });

  const { fetchData, isLoading } = useTriggeredAPICall();
  const { logout } = useAuthInfo();

  const validateForm = () => {
    const errors = {};

    if (password.new !== password.verify) {
      errors["password"] = "Passwords do not match";
    } else if (!isValidPassword(password.new)) {
      errors["password"] =
        "* Password must be between 8-20 characters with one special character, one number, and one capital letter.";
    }

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleFieldUpdate = (e) => {
    const { name, value } = e.target;

    setPassword((prev) => ({ ...prev, [name]: value }));

    if (formErrors.password)
      setFormErrors((prev) => ({ ...prev, password: null }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formValidation = validateForm();

    if (formValidation) {
      setFormErrors(formValidation);
      return;
    }

    const encodedString = match.params.token;
    const body = {
      token: encodedString,
      password: password.new,
    };

    fetchData(
      `/auth/forgot-password/${encodedString}`,
      "PUT",
      body,
      null,
      false
    )
      .then(async () => {
        successfulToast("Success! Password updated");
        await logout();
      })
      .catch((err) => {
        console.error("Change Password: ", err);
        errorToast(`Something went wrong, please try again later`);
        history.push("/login/forgot-password");
      });
  };

  return (
    <div className="mt-32 center">
      <Link to="/login">
        <img className="mb-16 height-10" src={Logo} alt="Logo" />
      </Link>
      <div className="width-500px height-600px py-8 px-16 card center">
        <h2>Change Your Password</h2>

        <div>{formErrors?.password}</div>

        <Form className="" onSubmit={handleSubmit}>
          <FormFieldPassword
            required
            name="new"
            label="New Password"
            value={password.new}
            placeholder="Enter your new password..."
            onChange={handleFieldUpdate}
          />

          <FormFieldPassword
            required
            name="verify"
            label="Verify New Password"
            value={password.verify}
            placeholder="Re-enter your new password..."
            onChange={handleFieldUpdate}
          />

          <button disabled={formErrors.password}>
            {isLoading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              "Change Password"
            )}
          </button>
        </Form>
      </div>
    </div>
  );
};

export default ChangePassword;
